import Vue from 'vue'
import Vuex from 'vuex'
import {tones, tonesMap, corr, maxAtt} from "../constants";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    gender: null,
    age: null,
    source: null,
    resultsL: {},
    resultsR: {},
    originalResultsL: [],
    originalResultsR: [],
    user: {
      firstName: '',
      lastName: '',
      email: '',
    },
    databaseUser: {
      email: '',
      password: '',
    },
    loadedResults: false,
  },
  mutations: {
    setGender(store, gender){
      store.gender = gender
    },
    setAge(store, age){
      store.age = age
    },
    setSource(store, source){
      store.source = source
      localStorage.setItem('source', source);
    },
    setResults(store, {originalL, originalR}){
      store.resultsL = rectifyAndMapResults(originalL)
      store.resultsR = rectifyAndMapResults(originalR)
      store.originalResultsL = originalL
      store.originalResultsR = originalR
    },
    setUser(store, user){
      store.user = user
    },
    setDBUser(store, databaseUser){
      store.databaseUser = databaseUser
    },
    setLoadedResults(state, loaded){
      state.loadedResults = loaded
      localStorage.setItem('loadedResults', loaded);
    }
  },
  getters: {
    isSpeaker: state => {
      return (state.source || localStorage.getItem('source')) === 'speakers'
    },
    isLoaded: state => {
      return state.loadedResults || localStorage.getItem('loadedResults') === 'true'
    }
  }
})

function rectifyAndMapResults(result) {

  let resCorrection = result.map((result, i) => -maxAtt[i] + result)

  let resDB = resCorrection.map((result, i) => result - corr[i])

  let maxDB = maxAtt.map((result, i) => -result - corr[i])

  let resRectified = resDB.map((result, i) => result === maxDB[i] ? 100 : result)

  resRectified = resRectified.map((result) => result <= 10 ? 0 : result)

  let sortedResults = {}

  resRectified.forEach((result, i) => {
    sortedResults[tonesMap[tones[i]]] = result
  })

  return sortedResults
}
